import { render, staticRenderFns } from "./CargoCrudStatusLoading.vue?vue&type=template&id=4dd3a0ab"
import script from "./CargoCrudStatusLoading.vue?vue&type=script&lang=js"
export * from "./CargoCrudStatusLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports